// extracted by mini-css-extract-plugin
export default {"status":"ChangeOrderStatus_status__cGXgz","card":"ChangeOrderStatus_card__pkSqd"};